export { atom } from 'jotai';

export { createAtomStore } from 'jotai-x';
